import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import SortableTableCell from '@eogile/agrements-common/src/components/table/SortableTableCell';
import { PaginationAndSortCommand } from '@eogile/agrements-common/src/components/table/tableTypes';
import { FdjUsersSortableFields } from '../fdjUsersTypes';

type Props = {
  onCommandChange: (newCommand: PaginationAndSortCommand<FdjUsersSortableFields>) => void;
  command: PaginationAndSortCommand<FdjUsersSortableFields>;
};

const FdjUsersTableHeader = ({ onCommandChange, command }: Props) => {
  return (
    <TableHead>
      <TableRow>
        <SortableTableCell<FdjUsersSortableFields>
          label="Login"
          sortField="LOGIN"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<FdjUsersSortableFields>
          label="Nom"
          sortField="LAST_NAME"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<FdjUsersSortableFields>
          label="Prénom"
          sortField="FIRST_NAME"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<FdjUsersSortableFields>
          label="Email"
          sortField="EMAIL"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<FdjUsersSortableFields>
          label="Secteur"
          sortField="AGENCY_CODE"
          onChange={onCommandChange}
          command={command}
        />
        <TableCell>Rôles</TableCell>
        <SortableTableCell<FdjUsersSortableFields>
          label="Date maj"
          sortField="UPDATED_AT"
          onChange={onCommandChange}
          command={command}
        />
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default FdjUsersTableHeader;
